import type { Metric } from 'web-vitals';

export default function reportWebVitals(
  onPerfEntry?: (metric: Metric) => void,
) {
  if (onPerfEntry) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
}
